<template>
  <div id="contenedor-agregar-auditoria-etiqueta">
    <v-card>
      <v-card-title>
        Seleccionar etiquetas
        <v-chip small class="ml-2">
          {{ etiquetasSeleccionadas.length }}
        </v-chip>
        <v-spacer></v-spacer>
        <v-btn @click="cerrar" icon>
          <v-icon class="secondary--text" large>highlight_off</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-list>
          <v-list-item-group v-model="etiquetasSeleccionadas" multiple>
            <template v-for="etiqueta in mixGetEtiquetas">
              <template>
                <v-list-item :key="etiqueta.id">
                  <template v-slot:default="{ active }">
                    <v-list-item-action>
                      <v-checkbox :color="etiqueta.color" :input-value="active"> </v-checkbox>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ etiqueta.descripcion }}
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-avatar :color="etiqueta.color" size="20"> </v-avatar>
                    </v-list-item-action>
                  </template>
                </v-list-item>
                <v-divider :key="`divisor-${etiqueta.id}`" class="mb-1"> </v-divider>
              </template>
            </template>
          </v-list-item-group>
        </v-list>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button @click="cerrar" tipo="formCancelar" label="Cancelar" class="mr-3">
        </custom-button>
        <custom-button
          tipo="formAceptar"
          label="Guardar"
          :disabled="!formularioValido || enviandoFormulario"
          :loading="enviandoFormulario"
          @click.prevent="mixGuardarEtiquetas"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import mixAuditoriasEtiquetas from './mixAuditoriasEtiquetas';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'AgregarEtiqueta',
  mixins: [mixAuditoriasEtiquetas],
  components: {
    CustomButton,
  },
  props: {
    idReferencia: {
      type: String,
      required: false,
    },
    etiquetasAgregadas: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      enviandoFormulario: false,
      mostrarSeleccionarEtiquetas: false,
      etiquetasSeleccionadas: [],
    };
  },
  methods: {
    cerrar() {
      this.etiquetasSeleccionadas = [];
      this.$emit('cerrar');
    },
  },
  computed: {
    getIdsEtiquetasSeleccionadas() {
      return this.mixGetEtiquetas
        .filter((_, index) => this.etiquetasSeleccionadas.includes(index))
        .map(({ id }) => id);
    },
    formularioValido() {
      return this.getIdsEtiquetasSeleccionadas.length > 0;
    },
  },
};
</script>

<style lang="scss"></style>
